'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002413 from "./presto.-Dashboard-View$$anon$13.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002415 from "./presto.-Dashboard-View$$anon$15.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002419 from "./presto.-Dashboard-View$$anon$19.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002421 from "./presto.-Dashboard-View$$anon$21.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002423 from "./presto.-Dashboard-View$$anon$23.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002425 from "./presto.-Dashboard-View$$anon$25.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dLogins$002dResponse$0024 from "./presto.types$-Dashboard-Logins-Response$.js";
import * as $j_presto$002etypes$0024$002dHost$0024 from "./presto.types$-Host$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$12(outer) {
  this.aJb = null;
  this.aJ3 = null;
  this.aJ4 = false;
  this.aJc = null;
  this.aJd = false;
  this.aJg = null;
  this.aJ9 = null;
  this.aJa = false;
  this.aJ5 = null;
  this.aJ6 = false;
  this.aJ7 = null;
  this.aJ8 = false;
  this.aJe = false;
  this.aJf = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aJb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aJg = "DashboardLoginsResponse";
}
export { $c_Lpresto_DashboardView$$anon$12 as $c_Lpresto_DashboardView$$anon$12 };
$p = $c_Lpresto_DashboardView$$anon$12.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$12;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$12() {
}
export { $h_Lpresto_DashboardView$$anon$12 as $h_Lpresto_DashboardView$$anon$12 };
$h_Lpresto_DashboardView$$anon$12.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aJb;
});
$p.L = (function() {
  if ((!this.aJ4)) {
    this.aJ3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aJ4 = true;
  }
  return this.aJ3;
});
$p.O = (function() {
  if ((!this.aJd)) {
    this.aJc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aJd = true;
  }
  return this.aJc;
});
$p.E = (function() {
  return this.aJg;
});
$p.t = (function() {
  if ((!this.aJa)) {
    this.aJ9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("total", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("errors", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("rate", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hosts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hostStats", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("systemStats", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("topUsers", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("topAccounts", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sign", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))))));
    this.aJa = true;
  }
  return this.aJ9;
});
$p.M = (function() {
  if ((!this.aJ6)) {
    this.aJ5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().o5, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44($j_presto$002etypes$0024$002dHost$0024.$m_Lpresto_types$Host$().v8())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002413.$c_Lpresto_DashboardView$$anon$13())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002415.$c_Lpresto_DashboardView$$anon$15())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002419.$c_Lpresto_DashboardView$$anon$19())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002421.$c_Lpresto_DashboardView$$anon$21())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002423.$c_Lpresto_DashboardView$$anon$23())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))))))));
    this.aJ6 = true;
  }
  return this.aJ5;
});
$p.Q = (function() {
  if ((!this.aJ8)) {
    this.aJ7 = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002425.$c_Lpresto_DashboardView$$anon$25();
    this.aJ8 = true;
  }
  return this.aJ7;
});
$p.w = (function() {
  if ((!this.aJf)) {
    this.aJe = false;
    this.aJf = true;
  }
  return this.aJe;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee128) => ((p) => \u03b4scrutinee128.cGv(p)))($j_presto$002etypes$0024$002dDashboard$002dLogins$002dResponse$0024.$m_Lpresto_types$DashboardLoginsResponse$())));
});
var $d_Lpresto_DashboardView$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$12, "presto.DashboardView$$anon$12", ({
  GE: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$12 as $d_Lpresto_DashboardView$$anon$12 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$12.js.map
